import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KycComponent } from './kyc.component';
import { KycService } from './kyc.service';
import { KycListComponent } from './kyc-list/kyc-list.component';
import { CreditCardComponent } from './credit-card/credit-card.component';
import { routing } from './kyc-routing.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [KycComponent, KycListComponent, CreditCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    MatSlideToggleModule,
    SharedModule,
    routing,
  ],
  providers: [KycService],
})
export class KycModule {}
